import { useEffect } from "react";

const LoadGoogleMapsAPI = ({ onLoad }) => {
    useEffect(() => {
        const isGoogleMapsLoaded = () =>
            window.google && window.google.maps && window.google.maps.places;

        if (!isGoogleMapsLoaded()) {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
            script.async = true;
            script.defer = true;

            script.onload = () => {
                if (isGoogleMapsLoaded() && onLoad) {
                    onLoad(); // Notify that the script and places library have loaded
                }
            };

            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script); // Cleanup script
            };
        } else {
            // Google Maps API is already loaded
            if (onLoad) {
                onLoad();
            }
        }
    }, [onLoad]);

    return null; // Script loader, no UI
};

export default LoadGoogleMapsAPI;
